import React from 'react';
import PropTypes from 'prop-types';
import { SOURCES } from 'client/utils/image-helpers';
import { Image } from 'site-modules/shared/components/image/image';
import { Link } from 'site-modules/shared/components/link/link';
import { RenderWhenViewable } from 'site-modules/shared/components/render-when-viewable/render-when-viewable';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

import './highly-rated-card.scss';

export function HighlyRatedCard({ vehicles }) {
  const { 'link-url': linkUrl, 'media-image': imageSrc, title: makeModelName } = vehicles;

  return (
    <div className="highly-rated-card col-6 col-md-4 px-0_5 mt-1_5">
      <Link className="underline" to={linkUrl}>
        <AspectRatioContainer aspectRatio="3:2">
          <RenderWhenViewable>
            <Image
              className="w-100 mb-1"
              imageId={imageSrc}
              alt={makeModelName}
              source={SOURCES.MEDIA}
              width={300}
              lazy
            />
          </RenderWhenViewable>
        </AspectRatioContainer>
        <p className="text-center mb-0">{makeModelName}</p>
      </Link>
    </div>
  );
}

HighlyRatedCard.propTypes = {
  vehicles: PropTypes.shape({
    'link-url': PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    'media-image': PropTypes.string.isRequired,
  }).isRequired,
};
